import { render, staticRenderFns } from "./DisbursementInput.vue?vue&type=template&id=0838813e&"
import script from "./DisbursementInput.vue?vue&type=script&lang=js&"
export * from "./DisbursementInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports